import React from 'react';
import { Menu, UnstyledButton, Group, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function WearablesDropdown({ onClose }) {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const isWearables = pathname.startsWith('/wearables');

  const handleItemClick = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <Menu
      trigger="hover"
      openDelay={100}
      closeDelay={400}
    >
      <Menu.Target>
        <UnstyledButton
          component={Link}
          to="/wearables/dashboard"
          style={{
            padding: '8px 12px',
            borderRadius: '4px',
            transition: 'background-color 0.2s',
          }}
        >
          <Group gap={4}>
            <Text c="dark.7" fw={isWearables ? 700 : undefined}>Wearables</Text>
            <IconChevronDown size={16} />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Overview</Menu.Label>
        <Menu.Item onClick={() => handleItemClick('/wearables/dashboard')}>
          Dashboard
        </Menu.Item>
        <Menu.Item onClick={() => handleItemClick('/wearables/find-correlations')}>
          Find Correlations
        </Menu.Item>
        
        <Menu.Divider />
        
        <Menu.Label>Metrics</Menu.Label>
        <Menu.Item onClick={() => handleItemClick('/wearables/heart-rate')}>
          Heart Rate
        </Menu.Item>
        <Menu.Item onClick={() => handleItemClick('/wearables/workouts')}>
          Workouts
        </Menu.Item>
        <Menu.Item onClick={() => handleItemClick('/wearables/sleep')}>
          Sleep
        </Menu.Item>
        {/* <Menu.Item onClick={() => handleItemClick('/wearables/activity')}>
          Activity
        </Menu.Item> */}
        <Menu.Item onClick={() => handleItemClick('/wearables/recovery')}>
          Recovery
        </Menu.Item>
        <Menu.Item onClick={() => handleItemClick('/wearables/body')}>
          Body
        </Menu.Item>
        
        <Menu.Divider />
        
        <Menu.Label>Devices</Menu.Label>
        <Menu.Item onClick={() => handleItemClick('/wearables/devices')}>
          Devices
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default WearablesDropdown;
